import { useState } from "react";

const usePagination = (
  initialPage = 0,
  initialPageSize = 10,
  initialTotal = 0
) => {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [total, setTotal] = useState(initialTotal);


  const handlePageChange = ({ current, pageSize: newSize }) => {
    setCurrentPage(current - 1); 
    setPageSize(newSize);
  };

  const paginationConfig = {
    current: currentPage + 1,
    pageSize,
    total,
  };

  return {
    currentPage,      
    pageSize,
    total,
    setTotal,
    setCurrentPage,
    setPageSize,
    handlePageChange,
    paginationConfig,
  };
};

export default usePagination;